
import AddForm from '@/components/Management/Store/AddForm';

export default {
  components: {
    AddForm
  }
};
